/** @format */

import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Sidebar() {
  const location = useLocation(); // Get current route
  const roleAccess = JSON.parse(localStorage.getItem("roleAccess")) || [];

  const menuItems = [
    { id: "dashboard", label: "Dashboard", link: "/" },
    { id: "puja_service", label: "Puja Service", link: "/service" },
    { id: "puja_category", label: "Puja Category", link: "/tag" },
    { id: "puja_service", label: "Geo Price", link: "/geo-price" },
    { id: "user", label: "User", link: "/users" },
    { id: "booking", label: "Booking", link: "/booking" },
    { id: "booking", label: "Add Past Bookings", link: "/add-past-booking" },
    { id: "booking", label: "Payments", link: "/payments" },
    { id: "task", label: "Task", link: "/task" },
    { id: "access_control", label: "Access Control", link: "/access-control" },
    { id: "refund", label: "Refund", link: "/refund" },
    { id: "testimonial", label: "Testimonials", link: "/testimonials" },
  ];

  const panditItems = [
    { id: "pandit_verification", label: "Pandit Verification",  link: "/pandit-verification"  },
    { id: "pandit_verification", label: "Allocation Dashboard", link: "/allocation-dashboard" },
    { id: "pandit_verification", label: "Dakshinas",            link: "/dakshinas"            },
    { id: "pandit_verification", label: "Puja Control",          link: "/puja-control"         },
  ];

  const eventItems = [
    { id: "puja_category", label: "Festival Pujas", link: "/festival-pujas" },
  ];

  const promotionItems = [
    { id: "segment", label: "User Segment", link: "/segment" },
    { id: "campaign", label: "Campaign", link: "/campaign" },
    { id: "promo_code", label: "Promo Code", link: "/promocode" },
    { id: "campaign", label: "Whatsapp Marketing", link: "/festival-campaign" },
    { id: "campaign", label: "Hero Banners", link: "/banner" },
  ];

  // Function to check read access
  const hasReadAccess = (privilegeId) => {
    const privilege = roleAccess.find((p) => p.privilege === privilegeId);
    return privilege?.read === true;
  };

  return (
    <div className="deznav">
      <div className="deznav-scroll">
        <ul className="metismenu" id="menu">
          <li>
            <a className="has-arrow" href="#!" onClick={(e) => e.preventDefault()} aria-expanded="false">
              <span className="nav-text">Dashboard</span>
            </a>
            <ul>
              {menuItems.filter((item) => hasReadAccess(item.id)).map((item) => (
                <li key={item.link}>
                  <Link to={item.link} className={`mb-2 ${location.pathname === item.link ? "mm-active" : ""}`}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </li>

          {/* Pandits Main Menu */}
          {panditItems.some((item) => hasReadAccess(item.id)) && (
            <li>
              <a className="has-arrow" href="#!" onClick={(e) => e.preventDefault()} aria-expanded="false">
                <span className="nav-text">Pandit Management</span>
              </a>
              <ul>
                {panditItems.filter((item) => hasReadAccess(item.id)).map((item) => (
                  <li key={item.link}>
                    <Link to={item.link} className={`mb-2 ${location.pathname.startsWith(item.link) ? "mm-active" : ""}`}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          )}

          {/* Events Main Menu */}
          {eventItems.some((item) => hasReadAccess(item.id)) && (
            <li>
              <a className="has-arrow" href="#!" onClick={(e) => e.preventDefault()} aria-expanded="false">
                <span className="nav-text">Events</span>
              </a>
              <ul>
                {eventItems.filter((item) => hasReadAccess(item.id)).map((item) => (
                  <li key={item.link}>
                    <Link to={item.link} className={`mb-2 ${location.pathname === item.link ? "mm-active" : ""}`}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </li>
          )}

          {/* Promotion Main Menu */}
          {promotionItems.some((item) => hasReadAccess(item.id)) && (
            <li>
              <a className="has-arrow" href="#!" onClick={(e) => e.preventDefault()} aria-expanded="false">
                <span className="nav-text">Promotion</span>
              </a>
              <ul>
                {promotionItems.filter((item) => hasReadAccess(item.id)).map((item) => (
                  <li key={item.link}>
                    <Link to={item.link} className={`mb-2 ${location.pathname === item.link ? "mm-active" : ""}`}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </li>
          )}

          {/* Strapi Dashboard */}
          <li>
            <a href="https://content.teertham.org/" target="_blank" rel="noopener noreferrer">
              <span className="nav-text">Strapi Dashboard</span>
            </a>
          </li>

        </ul>
      </div>
    </div>
  );
}

